import moment from "moment";

export const formatDateTimeLong = (date: Date) => {
  let returnDate = "";
  if (date) {
    const format = moment.localeData().longDateFormat("LLL");
    returnDate = moment(date).format(format);
  }
  return returnDate;
};
